module.exports = __webpack_public_path__ + "img/JAAvatar.133dd15e.webp";